import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestUpdates() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section header */}
        <div className="flex items-end justify-between mb-10">
          <div>
            <h3 className="text-sm font-semibold text-secondary-500 uppercase tracking-wider mb-2">
              <i className="ri-timer-flash-line mr-1.5"></i>
              最近更新
            </h3>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新上架内容
            </h2>
          </div>
        </div>

        {/* Updates list */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestUpdates.map((item) => (
            <Link
              key={item.id}
              to={item.link}
              className="group flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-200 cursor-pointer"
            >
              {/* Poster thumbnail */}
              <div className="w-20 h-28 md:w-24 md:h-32 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                    {item.title}
                  </h4>
                  <p className="text-xs text-foreground-500">{item.category}</p>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 font-medium">
                    {item.episode}
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="flex items-center gap-0.5 text-amber-500">
                      <i className="ri-star-fill text-xs"></i>
                      <span className="text-xs font-medium">{item.rating}</span>
                    </span>
                    <span className="text-xs text-foreground-400">{item.updateTime}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}